import ReactOnRails from 'react-on-rails';

import AddConfirmToCalendar from '../bundles/AddConfirmToCalendar/components/AddConfirmToCalendar';
import CheckoutAccordionApp from '../bundles/CheckoutAccordion/startup/CheckoutAccordionApp';
import MapWithMarker from '../bundles/MapWithMarker/components/MapWithMarker';
import AddToAppleWalletContainer from '../bundles/AddToWallet/AddToAppleWalletContainer';
import AddToGoogleWalletContainer from '../bundles/AddToWallet/AddToGoogleWalletContainer';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
  AddConfirmToCalendar,
  CheckoutAccordionApp,
  MapWithMarker,
  AddToAppleWalletContainer,
  AddToGoogleWalletContainer
});
